import { FaSearch } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const SecondHeader = ({
  title = 'Article',
  query,
  slug,
  activePath,
  onSearch,
  onChange
}) => {

  const navigate = useNavigate()

  return (
    <div className='bg-second-header'>

      <div className='px-4 md:px-6 lg:px-14 py-5 md:py-6'>

        {/* Title */}
        <h1 className='
text-2xl
sm:text-3xl
lg:text-[36px]
font-semibold
text-white
'>
          {title}
        </h1>


        <div className='lg:flex items-end mt-5 gap-6'>

          {/* Category Menu */}
          <div className='
flex-1
flex
overflow-x-auto
scrollbar-hide
gap-3
sm:gap-5
mb-4
lg:mb-0
whitespace-nowrap
'>

            <button
              onClick={() => navigate('/articles/category/trivia')}
              className='
px-4 py-2
rounded-full
bg-white/10
hover:bg-white/20
text-sm md:text-base
text-white
transition
'
            >
              Trivia
            </button>

            <button
              onClick={() => navigate('/articles/category/technology')}
              className='
px-4 py-2
rounded-full
bg-white/10
hover:bg-white/20
text-sm md:text-base
text-white
transition
'
            >
              Technology
            </button>

            <button
              onClick={() => navigate('/articles/category/bussiness')}
              className='
px-4 py-2
rounded-full
bg-white/10
hover:bg-white/20
text-sm md:text-base
text-white
transition
'
            >
              Bussiness
            </button>

          </div>


          {/* Search */}
          <div className='
flex-1
flex
flex-col
sm:flex-row
gap-3
sm:gap-4
'>

            <div className='
flex-1
flex
items-center
gap-2
border
bg-white
p-3
rounded-xl
focus-within:ring
focus-within:ring-green-500
'>

              <FaSearch className='text-slate-500 text-sm' />

              <input
                onChange={onChange}
                placeholder='Search article...'
                type='text'
                className='w-full outline-none bg-transparent text-sm md:text-base'
              />

            </div>


            <button
              onClick={onSearch}
              className='
py-3
px-5 md:px-6
bg-[#1AA79C]
hover:bg-[#159085]
rounded-xl
transition
w-full
sm:w-auto
'
            >
              <span className='text-white text-sm md:text-base'>
                Search
              </span>

              <span className='hidden lg:inline text-white ml-1'>
                Now
              </span>

            </button>

          </div>

        </div>
      </div>
    </div>
  )

}

export default SecondHeader